export default __webpack_public_path__ + "static/media/slider-img6.579923bc.png";